<template>
  <bita-modal
    :id="modalId"
    :title="'اولویت سالن های ' + driver.name"
    :isLoading="isLoading"
    :modal-lg="true"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row align-items-center">
            <bita-select
              name="salon"
              label="سالن"
              validation-container-class="col-12 col-md-4"
              input-class="form-control"
              :data-source="salons"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.salon_id"
            />
            <bita-input
              type="text"
              name="priority"
              label="اولویت"
              validation-container-class="col-12 col-md-6"
              input-class="form-control"
              v-model="dataForm.priority"
            />
            <bita-bootbutton
              type="primary"
              style="height: 33px"
              title="ذخیره"
              btn-width="100px"
              class="mt-3"
              @click.native="submit"
            />
          </div>

          <table class="table mt-2">
            <thead>
              <tr>
                <th>سالن</th>
                <th>اولویت</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in priorities">
                <td>{{ item.name }}({{ item.terminal_name }})</td>
                <td>{{ item.priority }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </bita-form>
    </div>
  </bita-modal>
</template>

<script>
import Spinner from "../../../components/Spinner";
export default {
  components: { Spinner },
  props: {
    modalId: {},
    title: {},
    propsDriver: {},
  },
  data() {
    return {
      driver: {},
      dataForm: {
        user_id: "",
        salon_id: "",
        priority: "",
      },
      isLoading: false,
      salons: [],
      priorities: [],
    };
  },
  mounted() {
    this.$persistClient("get", "management/salons").then((res) => {
      this.salons = res.data;
    });
  },
  watch: {
    propsDriver: function(_data) {
      this.driver = _data;
      this.dataForm.user_id = this.driver.user.id;

      this.getData();
    },
  },
  methods: {
    getData() {
      this.isLoading = true;
      this.$persistClient("get", `drivers/${this.dataForm.user_id}/salons`)
        .then((res) => {
          this.priorities = res.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    submit() {
      this.isLoading = true;
      this.$persistClient(
        "post",
        `drivers/${this.dataForm.user_id}/salons`,
        this.dataForm
      )
        .then((res) => {
          this.dataForm.salon_id = "";
          this.dataForm.priority = "";
          this.getData();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
